import Vue from 'vue';
import axios from "./axios.js"

var time=0

Vue.prototype.setTime=()=>{
	axios.get("data:gettime").then((e)=>{
		let d=new Date(e.Year,e.Mouth-1,e.Day,e.Hour,e.Min,e.Sec,e.MSec)
		let now=new Date()
		time=d.getTime()-now.getTime()
		sessionStorage.setItem('time',time)
	})
};

function dateinit(i){
	if(i<10){
		return '0' + i
	}
	return '' + i
}

Vue.prototype.getTime=()=>{
	if(time==0){
		time= +sessionStorage.getItem("time")
	}
	let now = new Date()
	let dateint = now.getTime() + time
	let d=new Date(dateint)
	let obj={
		year: d.getFullYear(),
		mouth: dateinit(d.getMonth() + 1),
		day: dateinit(d.getDate()),
		hour: dateinit(d.getHours()),
		min: dateinit(d.getMinutes()),
		sce: d.getSeconds(),
		week: "日一二三四五六".charAt(d.getDay()),
	}
	return obj
}